import {
  ModalHeader,
  ModalContent,
  ModalActions,
  Button,
  Text,
} from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import React, { FC } from 'react'

interface Props {
  onAccept: () => void
  onDecline: () => void
  signatureSrc?: string
}

export const ApproveSignature: FC<Props> = ({
  onAccept,
  onDecline,
  signatureSrc,
}) => {
  const t = useT()
  return (
    <>
      <ModalHeader>
        {t('Confirm customer signature to accept payment.', {
          _comment:
            'The payment prompt header indicates that the user should confirm the customer signature to accept the payment',
        })}
      </ModalHeader>
      <ModalContent>
        {signatureSrc ? (
          <div
            style={{ backgroundImage: `url(${signatureSrc})` }}
            className="swiper-signature vd-pa3"
          />
        ) : (
          <Text tag="p">
            {t(
              'Compare the signature on the receipt to the one on their card to accept the payment.',
              {
                _comment:
                  'The payment prompt description instructs the user to verify that the signature on the receipt matches the one on their card before accepting the payment.',
              }
            )}
          </Text>
        )}
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button variant="supplementary" onClick={onDecline}>
            {t('Decline', {
              _comment: 'Button label for declining',
            })}
          </Button>
          <Button variant="go" onClick={onAccept}>
            {t('Confirm and Accept', {
              _comment: 'Button label for confirming and accepting',
            })}
          </Button>
        </div>
      </ModalActions>
    </>
  )
}
